export const UPDATE_FORM_DATA = "DASHBOARD_UPDATE_FORM_DATA";
export const REINITIALIZE_CALENDARS = "DASHBOARD_REINITIALIZE_CALENDARS";
export const REINITIALIZE_FORM_DATA = "DASHBOARD_REINITIALIZE_FORM_DATA";
export const REINITIALIZE_PHOTOS = "DASHBOARD_REINITIALIZE_PHOTOS";
export const UPDATE_LISTING_PHOTOS = "DASHBOARD_UPDATE_LISTING_PHOTOS";
export const UPDATE_LISTING_PHOTOS_ORDER = "DASHBOARD_UPDATE_LISTING_PHOTOS_ORDER";
export const UPDATE_ICALS = "DASHBOARD_UPDATE_ICALS";
export const SET_LISTING = "DASHBOARD_SET_LISTING";
export const SET_LISTING_BOOKINGS = "DASHBOARD_SET_LISTING_BOOKINGS";
export const SET_LISTING_COLLECTION = "DASHBOARD_SET_LISTING_COLLECTION";
export const SET_DISCOUNTS = "SET_DISCOUNTS";
export const SET_SEARCHED_DISCOUNT = "SET_SEARCHED_DISCOUNT";

export const HousingTypeArray = ['House', 'Condo / Apartment', 'Cabin', 'Cottage', 'Bungalow', 'Studio', 'Townhouse',
  'Villa', 'Guesthouse', 'Farmhouse', 'Estate', 'Country House', 'Bed & Breakfast', 'Apartment', 'Condo', 'Townhome',
  'Hotel'];

export const AmenitiesArray = [
  "Air Conditioning*", "Bedding/Linens", "Cable TV*", "Coffee Maker", "Deck/Patio", "Dishes/Utensils",
  "Dishwasher", "DVD Player", "Fitness Room/Gym", "Game Room", "Garden/Backyard", "Grill", "Hairdryer",
  "Heating", "Hot Tub", "Indoor Fireplace", "Iron/Ironing Board", "Kitchen", "Microwave", "Paper Towels/Toilet Paper/Soap",
  "Off Street Parking*", "Pool", "Pool Table/Foosball Table", "Refrigerator", "Smart TV", "Smoke Detector", "Stove/Oven",
  "Street Parking", "Towels", "TV", "Washer/Dryer", "Wheelchair Accessible*", "WiFi*"
]

export const AmenitiesGroups = {
  "Essentials": ["Air Conditioning*", "WiFi*", "Heating", "Internet", "Wireless Broadband"],
  "Entertainment": ["Cable TV*", "DVD Player", "Fitness Room/Gym", "Fitness Room", "Gym", "Games", "Music Library", "Ping Pong Table",
    "Game Room", "Pool Table/Foosball Table", "Pool Table", "Foosball Table", "Smart TV", "TV", "Internet", "Wireless Broadband",
    "Stereo", "Television", "Toys", "Video Games", "Video Library",
  ],
  "Bedroom": ["Bedding/Linens", "Iron Board", "Linens"],
  "Kitchen": ["Kitchen", "Microwave", "Coffee Maker", "Dishes/Utensils", "Dishwasher", "Grill", "Refrigerator", "Stove/Oven"],
  "Bathroom": ["Hairdryer", "Hair Dryer", "Heating", "Hot Tub",
    "Paper Towels/Toilet Paper/Soap", "Paper Towels", "Toilet Paper", "Soap", "Towels"],
  "Outside": ["Deck/Patio", "Deck", "Patio", "Garden/Backyard", "Garden", "Backyard", "Pool", "Golf", "Veranda"],
  "Safety": ["Smoke Detector"],
  "Laundry": ["Washer/Dryer", "Washer", "Dryer"],
  "Parking": ["Off Street Parking*", "Street Parking", "Parking"],
  "Accessibility": ["Wheelchair Accessible*", "Accessibility Wheelchair Accessible"],
}

export const HostRules = {
  PETS_ALLOWED: "Pets Allowed",
  SMOKING_ALLOWED: "Smoking Allowed"
}

export const ListingFormSteps = [
  { step: 1, name: "details" },
  { step: 2, name: "descriptions" },
  { step: 3, name: "amenities" },
  { step: 4, name: "photos" },
  { step: 5, name: "photosOrder" },
  { step: 6, name: "pricing" },
  { step: 7, name: "addons" },
  { step: 8, name: "calendars" },
  { step: 9, name: "manageAvailability" },
  { step: 10, name: "preview" }
]

export const initialFormData = {
  listingName: '',
  address1: '',
  address2: '',
  zip: '',
  city: '',
  state: '',
  geometry: {
    lat: 0,
    lng: 0
  },
  houseType: 'House', //Possible Selections: House, Apartment, Condo, Townhouse, Guesthouse, Other
  bedrooms: 0,
  sleeps: 0,
  bathrooms: 0,
  about: '',
  sleepingArrangements: '',
  petsAllowed: false,
  smokingAllowed: false,
  amenities: [],
  photos: [],
  pricing: {
    baseFee: 0,
    cleaningFee: 0,
    petFee: 0,
    minNightStay: 1,
    localTax: 0,
    stateTax: 0,
    deposit: 20,
    overrides: [],
    extended_fee: {
      from: undefined,
      to: undefined,
      value: 0,
      enabled: false
    },
    weekend_fee: {
      from: undefined,
      to: undefined,
      value: 0,
      enabled: false
    }
  },
  addOns: [],
  discounts: [],
  calendars: [""],
  bookingSetting: '', //Possible Selections: Instant or Request
  terms: false,
  conditions: false,
  lastCompleted: 0,
  buttonClicked: '',
  capacitySet: false,
  tags: []
};

export const initListingData = {
  listingName: '',
  address: {
    address1: '',
    address2: '',
    zip: '',
    city: '',
    state: '',
  },
  geometry: {
    lat: 0,
    lng: 0
  },
  houseType: 'House', //Possible Selections: House, Apartment, Condo, Townhouse, Guesthouse, Other
  bedrooms: 0,
  sleeps: 0,
  bathrooms: 0,
  listingDetails: {
    about: '',
    sleepingArrangements: '',
    petsAllowed: false,
    smokingAllowed: false,
  },
  amenities: [],
  photos: [],
  pricing: {
    baseFee: 0,
    cleaningFee: 0,
    petFee: 0,
    minNightStay: 1,
    localTax: 0,
    stateTax: 0,
    deposit: 20,
    overrides: [],
    extended_fee: {
      from: undefined,
      to: undefined,
      value: 0,
      enabled: false
    },
    weekend_fee: {
      from: undefined,
      to: undefined,
      value: 0,
      enabled: false
    }
  },
  addOns: [],
  discounts: [],
  calendars: [],
  bookingSetting: 'Instant', //Possible Selections: Instant or Request
  isActive: false,
  isFeatured: false,
  lastCompleted: 0
}
